import { defineComponent as _defineComponent } from 'vue'
import {computed} from "vue";
import PaparaLogo from "./papara.svg"


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownLogoPapara',
  props: {
  height: {
    type: Number,
    default: 41
  },

},
  setup(__props) {

const props = __props;




const height = computed(() => props.height)
const width = computed(() => props.height * 94 / 26)

return { __sfc: true,props, height, width, PaparaLogo }
}

})